export enum EBudgetType {
  BUDGET_TYPE_SQUARE = 'square',
  BUDGET_TYPE_OVERALL = 'overall',
}
